import { cn } from "@/common/utils";
import CustomTypography from "@/components/Typography/CustomTypography";

export default function DefaultHeadColumns({
  text,
  className,
}: {
  text: string;
  className?: string;
}) {
  return (
    <>
      <div
        className={cn(
          "pointer h-full w-full flex justify-left items-end text-gray-dim gap-2 -mb-2",
          className
        )}
      >
        <CustomTypography
          as="span"
          case={"uppercase"}
          size="13px"
          weight={"normal"}
          family={"kanit"}
          color={"gray"}
          className="text-nowrap"
        >
          {!!text ? text : "No data"}
        </CustomTypography>
      </div>
    </>
  );
}
